import { z } from 'zod';
import { brandGradientSchema, isHexColor } from '@glomopay/utils';

import type { TTenantBranding } from './tenant-branding.types';

/**
 * Parses the tenant branding the backend attaches to API responses. The backend
 * compacts away unset keys and doesn't validate branding on write, so every field
 * degrades to its default instead of failing: branding rides on responses (the
 * payment session) whose failure would block the whole journey.
 */
export const tenantBrandingWireSchema: z.ZodType<TTenantBranding, z.ZodTypeDef, unknown> = z.object({
  theme: z
    .object({
      primaryColor: z.string().trim().refine(isHexColor).optional().catch(undefined),
      brandGradient: brandGradientSchema.nullish().catch(null),
    })
    .optional()
    .catch(undefined),
  fontFamily: z
    .string()
    .nullish()
    .transform((value) => value ?? null)
    .catch(null),
  fontsCssUrl: z
    .string()
    .nullish()
    .transform((value) => value ?? null)
    .catch(null),
  poweredByVisible: z
    .boolean()
    .nullish()
    .transform((value) => value ?? true)
    .catch(true),
  poweredByGlomoLogo: z
    .boolean()
    .nullish()
    .transform((value) => value ?? false)
    .catch(false),
  logoUrl: z
    .string()
    .nullish()
    .transform((value) => value ?? null)
    .catch(null),
  appName: z
    .string()
    .nullish()
    .transform((value) => value ?? '')
    .catch(''),
});
